import React from 'react';
import { BsChatRightTextFill } from 'react-icons/bs';
import StarRating from '../../../components/UI/StarRating';
import styles from '../FeedbackPage.module.css';

const QuestionSection2 = ({   activeSection, q2Rating, handleRatingChange, moveToPreviousSection, moveToNextSection, isLoading  }) => (
    <div 
    id="section-2" 
    className={`${styles.questionSection} ${activeSection === 2 ? styles.active : ''}`}
>
    <div className={styles.questionIcon}>
    <BsChatRightTextFill />
    </div>
    <label className={styles.questionLabel}>
        2. How would you rate the Title and Bullet Points generated? <span className={styles.required}>*</span>
    </label>
    <div className={styles.ratingContainer}>
        <StarRating
            rating={q2Rating}
            onRate={(rate) => handleRatingChange(2, rate)}
            disabled={isLoading}
            size={32}
        />
        {q2Rating > 0 && (
            <div className={styles.ratingText}>
                {q2Rating === 1 && 'Poor'}
                {q2Rating === 2 && 'Fair'}
                {q2Rating === 3 && 'Good'}
                {q2Rating === 4 && 'Very Good'}
                {q2Rating === 5 && 'Excellent'}
            </div>
        )}
    </div>
    <div className={styles.navigationButtons}>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnSecondary}`} 
            onClick={moveToPreviousSection}
        >
            Previous
        </button>
        <button 
            type="button" 
            className={`${styles.btn} ${styles.btnPrimary}`}  
            disabled={q2Rating === 0}
            onClick={moveToNextSection}
        >
            Next
        </button>
    </div>
</div>
);

export default QuestionSection2;
